/* ============================================================
   Floral · generic email capture → Klaviyo client subscribe.
   Attaches to any form[data-klaviyo-capture]; the form declares
   data-list (Klaviyo list id) and data-source (Signup Source).
   Wired 2026-08-25: footer/store locator → XEPCFm, blog CTA → Ydr23b.
   Re-pointed 2026-09-05 (Adam): footer, store locator, blog CTA → Ypd6PX
   (New Website Signups (2026)). THC-law forms stay on Ydr23b.
   ============================================================ */
(function(){
  'use strict';
  var COMPANY_ID = 'VaSiHk';

  function attach(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn   = form.querySelector('button[type="submit"]');
      var email = (input && input.value || '').trim();
      if(!email || email.indexOf('@') < 0){ if(input){ input.focus(); } return; }
      var orig = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; }

      var payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: { data: { type: "profile", attributes: {
              email: email,
              properties: {
                "Signup Source": form.dataset.source || "Site",
                "Signup Page": window.location.pathname
              }
            } } }
          },
          relationships: { list: { data: { type: "list", id: form.dataset.list } } }
        }
      };

      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + COMPANY_ID, {
        method: "POST",
        headers: {
          "accept": "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
          "revision": "2024-10-15"
        },
        body: JSON.stringify(payload)
      }).then(function(r){
        if(r.status === 202 || r.status === 201 || r.status === 200){
          if(btn){ btn.textContent = '\u2713'; }
          if(input){ input.value = ''; input.placeholder = "You're on the list"; }
          try { if(window.klaviyo){ window.klaviyo.identify({ "$email": email }); } } catch(err){}
        } else {
          if(btn){ btn.textContent = orig; btn.disabled = false; }
        }
      }).catch(function(){
        if(btn){ btn.textContent = orig; btn.disabled = false; }
      });
    });
  }

  function init(){ document.querySelectorAll('form[data-klaviyo-capture]').forEach(attach); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
